<template>
  <div class="w-100 row no-gutters">
    <div class="col-12">
      <h1>{{title}}</h1>
    </div>
    <div class="col-4 px-2" v-for="(data, index) in dataList">
      <div class="d-flex flex-column">
        <h2>{{data.titleH2}}</h2>
        <p>{{data.contentP}}</p>
        <a :href="data.buttonUrl" class="btn btn-sm btn-primary">
          {{data.buttonName}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      title: {
        type: String
      },
      dataList: {
        type: Array
      }
    },
  };

</script>
